import type { BrandColor } from '@app-types/color'
import type { IconComponent } from '@components/icons/types'
import type { JSX } from 'react'

/**
 * Renders a Copy icon.
 */
export const Copy: IconComponent<Props & JSX.IntrinsicElements['svg']> = ({
    color,
    width,
    height,
    ...restOfProps
}) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 15 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...restOfProps}
    >
        <g clipPath='url(#a)' fill='currentColor'>
            <path d='M8.796 6.164v8.395H2.219V6.164h6.577Zm0-1.449H2.219c-.762 0-1.386.652-1.386 1.449v8.395c0 .796.624 1.448 1.386 1.448h6.577c.762 0 1.386-.652 1.386-1.448V6.164c0-.804-.617-1.449-1.386-1.449Z' />
            <path d='M12.78 0H6.205c-.762 0-1.386.652-1.386 1.449v1.818h1.386V1.449h6.577v8.394h-1.213v1.449h1.213c.762 0 1.386-.652 1.386-1.449V1.45C14.167.652 13.543 0 12.78 0Z' />
        </g>
        <defs>
            <clipPath id='a'>
                <path
                    fill='#fff'
                    transform='translate(.833)'
                    d='M0 0h13.333v16H0z'
                />
            </clipPath>
        </defs>
    </svg>
)

interface Props {
    color?: BrandColor
}
